import {
  HttpEvent, HttpHandler, HttpInterceptor, HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';
import { environment } from '../environments/environment';

@Injectable()
export class Loading implements HttpInterceptor {
    constructor() {}
    intercept(
      req: HttpRequest<any>,
      next: HttpHandler
    ): Observable<HttpEvent<any>> {
      if(req.url.includes(environment.appUrl))
        sessionStorage.setItem('isLoading', '1');      
      return next.handle(req).finally(() => {
        if(req.url.includes(environment.appUrl))
          sessionStorage.setItem('isLoading', '0');        
      }).catch((error, caught) => {
        return Observable.throw(error);
      }) as any;
    }
  }


// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/loading.ts